//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cms from '~/mixins/cms';

export default {
  cmsId: 'shipper-info',
  name: 'shipper-info',
  platforms: ['CABINET'],
  access: '*',
  mixins: [cms],
  computed: {
    title () {
      return this.content.heading;
    },
    sectionItems () {
      const children = [
        'preparation-memos',
        'cargo-sales-agents',
        'products-and-services',
        'aircraft-and-packaging',
      ];
      return (this.publicNavigation || []).filter(item => {
        return children.includes(item.id);
      });
    },
  },
};
